import React, { useState, useCallback, useEffect } from 'react';
import { useDropzone } from 'react-dropzone';
import axios from 'axios';
import AuthUser from '../services/AuthUser';




const CreateTicket = () => {
  const [formData, setFormData] = useState({
    author_name: '',
    author_email: '',
    title: '',
    content: ''
  });
  const { http, setToken } = AuthUser();
  const [uploaded, setUploaded] = useState([]); // For backend media filenames
  const [attachmentsPreview, setAttachmentsPreview] = useState([]); // For UI preview
  const [status, setStatus] = useState(null);

  useEffect(() => {
  const user = JSON.parse(localStorage.getItem('user'));
  if (user?.name && user?.email) {
    setFormData(prev => ({
      ...prev,
      author_name: user.name,
      author_email: user.email
    }));
  }
}, []);


  const onDrop = useCallback((acceptedFiles) => {
    acceptedFiles.forEach(file => {
      const data = new FormData();
      data.append('file', file);
      data.append('size', 2);

      http.post('/tickets/media', data, {
        headers: { 'Content-Type': 'multipart/form-data' }
      })
        .then(res => {
          if (res.data?.name) {
            // Add preview URL here
            const previewUrl = URL.createObjectURL(file);
            setUploaded(prev => [...prev, res.data.name]);
            setAttachmentsPreview(prev => [...prev, {
              name: file.name,
              serverName: res.data.name,
              preview: previewUrl
            }]);
          }
        })
        .catch(err => {
          console.error('Upload failed:', err);
        });
    });
  }, [http]);



  const { getRootProps, getInputProps, isDragActive } = useDropzone({ onDrop });

  const handleChange = e => {
    setFormData(prev => ({ ...prev, [e.target.name]: e.target.value }));
  };

  const handleRemoveFile = (fileName) => {
    // Remove by name from previews
    setAttachmentsPreview(prev => prev.filter(f => f.name !== fileName));
    // Remove by matching serverName from uploaded
    setUploaded(prev => {
      // Find serverName from previews first
      const removedFile = attachmentsPreview.find(f => f.name === fileName);
      if (!removedFile) return prev;
      return prev.filter(name => name !== removedFile.serverName);
    });
  };


  const handleSubmit = e => {
    e.preventDefault();

    const payload = {
      ...formData,
      attachments: uploaded // These should match what Laravel expects
    };

    http.post('/tickets', payload)
      .then(res => {
        setStatus('✅ Ticket created successfully!');
        setFormData({ author_name: '', author_email: '', title: '', content: '' });
        setUploaded([]);
        setAttachmentsPreview([]);
      })
      .catch(err => {
        console.error(err);
        setStatus('❌ Failed to create ticket.');
      });
  };

  return (
    <div className="container mt-4">

      {status && <div className="alert alert-info">{status}</div>}
      <form onSubmit={handleSubmit}>
        <div className="form-group row">
          <label className="col-md-4 col-form-label text-md-right">Your Name</label>
          <div className="col-md-6">
            <input type="text" className="form-control" name="author_name" value={formData.author_name} onChange={handleChange} required />
          </div>
        </div>
        <div className="form-group row">
          <label className="col-md-4 col-form-label text-md-right">Your Email</label>
          <div className="col-md-6">  <input type="email" className="form-control" name="author_email" value={formData.author_email} onChange={handleChange} required /></div>

        </div>
        <div className="form-group row">
          <label className="col-md-4 col-form-label text-md-right">Title</label>
          <div className="col-md-6">  <input type="text" className="form-control" name="title" value={formData.title} onChange={handleChange} required /></div>

        </div>
        <div className="form-group row">
          <label className="col-md-4 col-form-label text-md-right">Content</label>
          <div className="col-md-6">    <textarea className="form-control" rows="3" name="content" value={formData.content} onChange={handleChange} required></textarea></div>

        </div>
        <div className="form-group row">
          <label className="col-md-4 col-form-label text-md-right">Attachments</label>
          <div className="col-md-6">
            <div {...getRootProps()} className="border p-3 text-center" style={{ background: '#f8f9fa', cursor: 'pointer', minHeight: '120px' }}>
              <input {...getInputProps()} />

              {attachmentsPreview.length > 0 ? (
                <div className="d-flex flex-wrap justify-content-center gap-2">
                  {attachmentsPreview.map((file, index) => (
                    <div key={index} style={{ position: 'relative', width: 80, height: 80, borderRadius: 6, overflow: 'hidden', border: '1px solid #ccc' }}>
                      <img
                        src={file.preview}
                        alt={file.name}
                        style={{ width: '100%', height: '100%', objectFit: 'cover' }}
                      />
                      <button
                        type="button"
                        onClick={(e) => {
                          e.stopPropagation(); // prevent triggering file dialog
                          handleRemoveFile(file.name);
                        }}
                        style={{
                          position: 'absolute',
                          top: 2,
                          right: 2,
                          background: 'rgba(0,0,0,0.6)',
                          border: 'none',
                          color: 'white',
                          borderRadius: '50%',
                          width: 20,
                          height: 20,
                          cursor: 'pointer',
                          fontSize: 14,
                          lineHeight: '18px',
                          padding: 0,
                        }}
                        aria-label={`Remove ${file.name}`}
                      >
                        ×
                      </button>
                    </div>
                  ))}
                </div>
              ) : (
                <p style={{ lineHeight: '100px', margin: 0 }}>
                  {isDragActive ? 'Drop the files here...' : 'Drag & drop files here or click to upload'}
                </p>
              )}
            </div>


          


          </div>
        </div>

        {/* <button type="submit" className="btn btn-primary"></button> */}
        <div className="form-group row mb-0">
          <div className="col-md-8 offset-md-4">
            <button type="submit" className="btn btn-primary">
              Submit Ticket
            </button>
          </div>
        </div>
      </form>
    </div>
  );
};

export default CreateTicket;
